import { useCallback, useEffect, useRef, useState } from 'react';

const MAP_PRELOAD_MARGIN = '600px 0px';

export const useLazyMapRender = () => {
  const mapBlockRef = useRef<HTMLDivElement | null>(null);
  const [mapBlockElement, setMapBlockElement] = useState<HTMLDivElement | null>(
    null
  );
  const [isMapVisible, setIsMapVisible] = useState(false);

  const setMapBlockRef = useCallback((element: HTMLDivElement | null) => {
    mapBlockRef.current = element;
    setMapBlockElement(element);
  }, []);

  useEffect(() => {
    if (!mapBlockElement || isMapVisible) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      setIsMapVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) setIsMapVisible(true);
      },
      { rootMargin: MAP_PRELOAD_MARGIN }
    );

    observer.observe(mapBlockElement);

    return () => observer.disconnect();
  }, [mapBlockElement, isMapVisible]);

  return { mapBlockRef, setMapBlockRef, isMapVisible };
};
